import * as React from 'react';
import * as classNames from 'classnames';
import './styles.scss';
import HeadingWithButtons, { IHeadingWithButtonsProps } from '../../Components/HeadingWithButtons';
import Block from '../../Components/Block';

export interface ILayoutOverlayProps extends IHeadingWithButtonsProps {
    /** className to append */
    className?: string;
    /** className to append to heading container */
    headingClassName?: string;
    /** className to append to content container */
    contentClassName?: string;
    /** Page title */
    title?: string;
    /** Container size */
    size?: 'default' | 'max' | 'wide' | 'medium' | 'small';
    /** Make content scrollable */
    scrollableContent?: boolean;
    description?: string;
    isFocusOnFirstButton?: boolean;
    outsideClickClose?: boolean;
    outsideClickClosefn?: () => void;
    theme?: 'lightest' | 'lighter' |'light' | 'dark' | 'darker' | 'darkest' | 'success' | 'danger' | 'warning' | 'navy';
}

interface IState {

}

/**
 * Basic list wrapper.
 */
class LayoutOverlay extends React.Component<ILayoutOverlayProps, IState> {
    static displayName: string = 'LayoutOverlay';
    private wrapperRef;
    constructor(props) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            // alert('You clicked outside of me!');
            !!this.props.outsideClickClosefn ? this.props.outsideClickClosefn() : '';
        }
    }
    render() {
        return (
            <div className={classNames('layout-overlay', {
                'size-default': this.props.size === 'default' || !this.props.size,
                'size-max': this.props.size === 'max',
                'size-wide': this.props.size === 'wide',
                'size-medium': this.props.size === 'medium',
                'size-small': this.props.size === 'small',
            }, this.props.className)}>
                <div ref={!!this.props.outsideClickClose ? this.setWrapperRef : undefined} className="layout-overlay-inner">
                    {this.props.title && <Block
                        className={classNames('layout-overlay-heading', this.props.headingClassName)}
                        theme={this.props.theme || "darker"}
                    >
                        <HeadingWithButtons
                            level={1}
                            title={this.props.title}
                            buttons={this.props.buttons}
                            buttonIcons={this.props.buttonIcons}
                            description={this.props.description}
                            isFocusOnFirstButton={!!this.props.isFocusOnFirstButton ? true : false}
                        />
                    </Block>}
                    <div className={classNames('layout-overlay-content', 'alternate-blocks', {
                        scrollable: this.props.scrollableContent,
                    })}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default LayoutOverlay;
